"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2227],{

/***/ 67163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Tab; }
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function Tab(props) {
  return null;
}

/***/ }),

/***/ 78557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ Tabs; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-uid/dist/es2015/hooks.js
var hooks = __webpack_require__(37424);
// EXTERNAL MODULE: ./node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(67265);
// EXTERNAL MODULE: ./node_modules/baseui/esm/helpers/overrides.js
var helpers_overrides = __webpack_require__(92338);
// EXTERNAL MODULE: ./node_modules/baseui/esm/utils/focusVisible.js
var utils_focusVisible = __webpack_require__(73495);
;// CONCATENATED MODULE: ./node_modules/baseui/esm/tabs-motion/constants.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var ORIENTATION = {
  vertical: 'vertical',
  horizontal: 'horizontal'
};
var FILL = {
  fixed: 'fixed',
  intrinsic: 'intrinsic'
};
var STATE_CHANGE_TYPE = {
  change: 'change'
};
;// CONCATENATED MODULE: ./node_modules/baseui/esm/tabs-motion/utils.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


var getTabId = function getTabId(uid, key) {
  return "tabs-".concat(uid, "-tab-").concat(key);
};
var getTabPanelId = function getTabPanelId(uid, key) {
  return "tabs-".concat(uid, "-tabpanel-").concat(key);
};
var isHorizontal = function isHorizontal(orientation) {
  return orientation === ORIENTATION.horizontal;
};
var isVertical = function isVertical(orientation) {
  return orientation === ORIENTATION.vertical;
};
var isRTL = function isRTL(direction) {
  return direction === 'rtl';
};
var isIntrinsic = function isIntrinsic(fill) {
  return fill === FILL.intrinsic;
};
var isFixed = function isFixed(fill) {
  return fill === FILL.fixed;
};
;// CONCATENATED MODULE: ./node_modules/baseui/esm/tabs-motion/styled-components.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/



var StyledRoot = (0,styled/* styled */.zo)('div', function (_ref) {
  var $theme = _ref.$theme,
      _ref$$orientation = _ref.$orientation,
      $orientation = _ref$$orientation === void 0 ? ORIENTATION.horizontal : _ref$$orientation;
  var style = {
    // Creates a stacking context so we can use z-index on the TabHighlight
    // without affecting anything outside of this element.
    transform: 'scale(1)'
  };

  if (isVertical($orientation)) {
    style.display = 'flex';
  }

  return style;
});
StyledRoot.displayName = "StyledRoot";
var StyledTabList = (0,styled/* styled */.zo)('div', function (_ref2) {
  var $theme = _ref2.$theme,
      _ref2$$fill = _ref2.$fill,
      $fill = _ref2$$fill === void 0 ? FILL.intrinsic : _ref2$$fill,
      _ref2$$orientation = _ref2.$orientation,
      $orientation = _ref2$$orientation === void 0 ? ORIENTATION.horizontal : _ref2$$orientation;
  var style = {
    position: 'relative',
    display: 'flex',
    flexWrap: 'nowrap'
  };

  if (isHorizontal($orientation)) {
    style.flexDirection = 'row';
    style.paddingBottom = '5px';
    style.marginBottom = '-5px';
  } else {
    style.flexDirection = 'column';

    if (isRTL($theme.direction)) {
      style.paddingLeft = '5px';
      style.marginLeft = '-5px';
    } else {
      style.paddingRight = '5px';
      style.marginRight = '-5px';
    }
  }

  if (isIntrinsic($fill)) {
    style['::-webkit-scrollbar'] = {
      display: 'none'
    }; // $FlowFixMe: property missing in StyleObject

    style['-ms-overflow-style'] = 'none';
    style.scrollbarWidth = 'none';

    if (isHorizontal($orientation)) {
      style.overflowX = 'scroll';
    } else {
      style.overflowY = 'scroll';
    }
  }

  return style;
});
StyledTabList.displayName = "StyledTabList";
var StyledTab = (0,styled/* styled */.zo)('button', function (_ref3) {
  var $theme = _ref3.$theme,
      _ref3$$orientation = _ref3.$orientation,
      $orientation = _ref3$$orientation === void 0 ? ORIENTATION.horizontal : _ref3$$orientation,
      _ref3$$fill = _ref3.$fill,
      $fill = _ref3$$fill === void 0 ? FILL.intrinsic : _ref3$$fill,
      _ref3$$focusVisible = _ref3.$focusVisible,
      $focusVisible = _ref3$$focusVisible === void 0 ? false : _ref3$$focusVisible,
      _ref3$$isActive = _ref3.$isActive,
      $isActive = _ref3$$isActive === void 0 ? false : _ref3$$isActive;

  var style = _objectSpread({
    cursor: 'pointer',
    WebkitAppearance: 'none',
    marginLeft: '0',
    marginRight: '0',
    marginTop: '0',
    marginBottom: '0',
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    paddingLeft: $theme.sizing.scale600,
    paddingTop: $theme.sizing.scale600,
    paddingRight: $theme.sizing.scale600,
    paddingBottom: $theme.sizing.scale600,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftStyle: 'none',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderBottomStyle: 'none',
    color: $theme.colors.contentPrimary,
    background: $theme.colors.backgroundPrimary,
    transitionProperty: 'background',
    transitionDuration: $theme.animation.timing200,
    transitionTimingFunction: $theme.animation.linearCurve,
    outline: 'none',
    outlineOffset: '-3px',
    ':disabled': {
      cursor: 'not-allowed',
      color: $theme.colors.contentStateDisabled
    },
    ':hover': {
      background: $theme.colors.backgroundSecondary
    },
    ':disabled:hover': {
      background: 'none'
    }
  }, $theme.typography.LabelSmall);

  if ($focusVisible) {
    style.outline = "3px solid ".concat($theme.colors.accent);
  }

  if (isFixed($fill)) {
    style.flexGrow = 1;
    style.flexBasis = 0;
  }

  if (isHorizontal($orientation)) {
    style.justifyContent = 'center';
  } else {
    style.justifyContent = 'flex-end';
  }

  return style;
});
StyledTab.displayName = "StyledTab";
var StyledArtworkContainer = (0,styled/* styled */.zo)('div', function (_ref4) {
  var $theme = _ref4.$theme,
      _ref4$$orientation = _ref4.$orientation,
      $orientation = _ref4$$orientation === void 0 ? ORIENTATION.horizontal : _ref4$$orientation;
  var style = {
    display: 'flex'
  };

  if (isRTL($theme.direction)) {
    style.marginLeft = $theme.sizing.scale300;
  } else {
    style.marginRight = $theme.sizing.scale300;
  }

  return style;
});
StyledArtworkContainer.displayName = "StyledArtworkContainer";
var StyledTabBorder = (0,styled/* styled */.zo)('div', function (_ref5) {
  var $theme = _ref5.$theme,
      _ref5$$orientation = _ref5.$orientation,
      $orientation = _ref5$$orientation === void 0 ? ORIENTATION.horizontal : _ref5$$orientation;
  var style = {
    backgroundColor: $theme.colors.borderOpaque,
    position: 'relative'
  };

  if (isHorizontal($orientation)) {
    style.height = '5px';
  } else {
    style.width = '5px';
  }

  return style;
});
StyledTabBorder.displayName = "StyledTabBorder";
var StyledTabHighlight = (0,styled/* styled */.zo)('div', function (_ref6) {
  var $theme = _ref6.$theme,
      _ref6$$orientation = _ref6.$orientation,
      $orientation = _ref6$$orientation === void 0 ? ORIENTATION.horizontal : _ref6$$orientation,
      _ref6$$length = _ref6.$length,
      $length = _ref6$$length === void 0 ? 0 : _ref6$$length,
      _ref6$$distance = _ref6.$distance,
      $distance = _ref6$$distance === void 0 ? 0 : _ref6$$distance,
      _ref6$$animate = _ref6.$animate,
      $animate = _ref6$$animate === void 0 ? false : _ref6$$animate;
  var style = {
    backgroundColor: $theme.colors.borderSelected,
    position: 'absolute',
    zIndex: 1
  };

  if (isHorizontal($orientation)) {
    style.bottom = '0px';
    style.left = '0px';
    style.height = '5px';
    style.width = "".concat($length, "px");
    style.transform = "translateX(".concat($distance, "px)");
  } else {
    style.transform = "translateY(".concat($distance, "px)");
    style.width = '5px';
    style.height = "".concat($length, "px");

    if (isRTL($theme.direction)) {
      style.left = '0px';
    } else {
      style.right = '0px';
    }
  }

  if ($animate) {
    style.transitionProperty = 'all';
    style.transitionDuration = $theme.animation.timing400;
    style.transitionTimingFunction = $theme.animation.easeInOutQuinticCurve;
  }

  return style;
});
StyledTabHighlight.displayName = "StyledTabHighlight";
var StyledTabPanel = (0,styled/* styled */.zo)('div', function (_ref7) {
  var $theme = _ref7.$theme,
      _ref7$$pad = _ref7.$pad,
      $pad = _ref7$$pad === void 0 ? true : _ref7$$pad;
  var style = {
    flexGrow: 1,
    // only used in vertical orientation
    outline: 'none'
  };

  if ($pad) {
    style.paddingTop = $theme.sizing.scale600;
    style.paddingRight = $theme.sizing.scale600;
    style.paddingBottom = $theme.sizing.scale600;
    style.paddingLeft = $theme.sizing.scale600;
  }

  return style;
});
StyledTabPanel.displayName = "StyledTabPanel";
;// CONCATENATED MODULE: ./node_modules/baseui/esm/tabs-motion/tabs.js
function tabs_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function tabs_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { tabs_ownKeys(Object(source), true).forEach(function (key) { tabs_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { tabs_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function tabs_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* global window */








var KEYBOARD_ACTION = {
  next: 'next',
  previous: 'previous'
};

var getLayoutParams = function getLayoutParams(el, orientation) {
  if (!el) {
    return {
      length: 0,
      distance: 0
    };
  } // Note, we are using clientHeight/Width here, which excludes borders.
  // This means borders won't be taken into account if someone adds borders
  // through overrides. In that case you would use getBoundingClientRect
  // which includes borders, but because it returns a fractional value the
  // highlight is slightly misaligned every so often.


  if (isVertical(orientation)) {
    return {
      length: el.clientHeight,
      distance: el.offsetTop
    };
  } else {
    return {
      length: el.clientWidth,
      distance: el.offsetLeft
    };
  }
};

var scrollParentToCentreTarget = function scrollParentToCentreTarget(targetNode) {
  var _targetNode$parentNod = targetNode.parentNode.getBoundingClientRect(),
      parentX = _targetNode$parentNod.x,
      parentY = _targetNode$parentNod.y,
      parentWidth = _targetNode$parentNod.width,
      parentHeight = _targetNode$parentNod.height;

  var _targetNode$getBoundi = targetNode.getBoundingClientRect(),
      childX = _targetNode$getBoundi.x,
      childY = _targetNode$getBoundi.y,
      childWidth = _targetNode$getBoundi.width,
      childHeight = _targetNode$getBoundi.height; // get the position of the child centre, relative to parent


  var childCentre = {
    x: childX - parentX + childWidth / 2,
    y: childY - parentY + childHeight / 2
  }; // aim for the centre of the child to be the centre of the parent

  var _targetNode$parentNod2 = targetNode.parentNode,
      scrollLeft = _targetNode$parentNod2.scrollLeft,
      scrollTop = _targetNode$parentNod2.scrollTop;
  var target = {
    x: scrollLeft + childCentre.x - parentWidth / 2,
    y: scrollTop + childCentre.y - parentHeight / 2
  }; // ignore out of bounds, the browser will manage this for us

  targetNode.parentNode.scroll(target.x, target.y);
};

function Tabs(_ref) {
  var _ref$activeKey = _ref.activeKey,
      activeKey = _ref$activeKey === void 0 ? '0' : _ref$activeKey,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      children = _ref.children,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? FILL.intrinsic : _ref$fill,
      _ref$activateOnFocus = _ref.activateOnFocus,
      activateOnFocus = _ref$activateOnFocus === void 0 ? true : _ref$activateOnFocus,
      onChange = _ref.onChange,
      _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === void 0 ? ORIENTATION.horizontal : _ref$orientation,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
      _ref$renderAll = _ref.renderAll,
      renderAll = _ref$renderAll === void 0 ? false : _ref$renderAll,
      _ref$uid = _ref.uid,
      customUid = _ref$uid === void 0 ? null : _ref$uid;
  // Create unique id prefix for this tabs component
  var generatedUid = (0,hooks/* useUID */.D)();
  var uid = customUid || generatedUid; // Unpack overrides

  var RootOverrides = overrides.Root,
      TabListOverrides = overrides.TabList,
      TabHighlightOverrides = overrides.TabHighlight,
      TabBorderOverrides = overrides.TabBorder;

  var _getOverrides = (0,helpers_overrides/* getOverrides */.jb)(RootOverrides, StyledRoot),
      _getOverrides2 = _slicedToArray(_getOverrides, 2),
      Root = _getOverrides2[0],
      RootProps = _getOverrides2[1];

  var _getOverrides3 = (0,helpers_overrides/* getOverrides */.jb)(TabListOverrides, StyledTabList),
      _getOverrides4 = _slicedToArray(_getOverrides3, 2),
      TabList = _getOverrides4[0],
      TabListProps = _getOverrides4[1];

  var _getOverrides5 = (0,helpers_overrides/* getOverrides */.jb)(TabHighlightOverrides, StyledTabHighlight),
      _getOverrides6 = _slicedToArray(_getOverrides5, 2),
      TabHighlight = _getOverrides6[0],
      TabHighlightProps = _getOverrides6[1];

  var _getOverrides7 = (0,helpers_overrides/* getOverrides */.jb)(TabBorderOverrides, StyledTabBorder),
      _getOverrides8 = _slicedToArray(_getOverrides7, 2),
      TabBorder = _getOverrides8[0],
      TabBorderProps = _getOverrides8[1]; // Count key updates
  // We disable a few things until after first mount:
  // - the highlight animation, avoiding an initial slide-in
  // - smooth scrolling active tab into view


  var _React$useState = react.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      keyUpdated = _React$useState2[0],
      setKeyUpdated = _React$useState2[1];

  react.useEffect(function () {
    setKeyUpdated(keyUpdated + 1);
  }, [activeKey]); // Positioning the highlight.

  var activeTabRef = react.useRef();

  var _React$useState3 = react.useState({
    length: 0,
    distance: 0
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      highlightLayout = _React$useState4[0],
      setHighlightLayout = _React$useState4[1]; // Create a shared, memoized callback for tabs to call on resize.


  var updateHighlight = react.useCallback(function () {
    if (activeTabRef.current) {
      setHighlightLayout(getLayoutParams(activeTabRef.current, orientation));
    }
  }, [activeTabRef.current, orientation]); // Update highlight on key and orientation changes.

  react.useEffect(updateHighlight, [activeTabRef.current, orientation]); // Scroll active tab into view when the parent has scrollbar on mount and
  // on key change (smooth scroll). Note, if the active key changes while
  // the tab is not in view, the page will scroll it into view.
  // TODO: replace with custom scrolling logic.

  react.useEffect(function () {
    // Flow needs this condition pulled out.
    if (activeTabRef.current) {
      if (isHorizontal(orientation) ? activeTabRef.current.parentNode.scrollWidth > activeTabRef.current.parentNode.clientWidth : activeTabRef.current.parentNode.scrollHeight > activeTabRef.current.parentNode.clientHeight) {
        if (keyUpdated > 1) {
          activeTabRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        } else {
          scrollParentToCentreTarget(activeTabRef.current);
        }
      }
    }
  }, [activeTabRef.current]); // Collect shared styling props

  var sharedStylingProps = {
    $orientation: orientation,
    $fill: fill
  }; // Helper for parsing directional keys
  // TODO(WPT-6473): move to universal keycode aliases

  var _useStyletron = (0,styled/* useStyletron */.hQ)(),
      _useStyletron2 = _slicedToArray(_useStyletron, 2),
      theme = _useStyletron2[1];

  var parseKeyDown = react.useCallback(function (event) {
    if (isHorizontal(orientation)) {
      if (isRTL(theme.direction)) {
        switch (event.keyCode) {
          case 39:
            return KEYBOARD_ACTION.previous;

          case 37:
            return KEYBOARD_ACTION.next;

          default:
            return null;
        }
      } else {
        switch (event.keyCode) {
          case 37:
            return KEYBOARD_ACTION.previous;

          case 39:
            return KEYBOARD_ACTION.next;

          default:
            return null;
        }
      }
    } else {
      switch (event.keyCode) {
        case 38:
          return KEYBOARD_ACTION.previous;

        case 40:
          return KEYBOARD_ACTION.next;

        default:
          return null;
      }
    }
  }, [orientation, theme.direction]);
  return /*#__PURE__*/react.createElement(Root, _extends({}, sharedStylingProps, RootProps), /*#__PURE__*/react.createElement(TabList, _extends({
    "data-baseweb": "tab-list",
    role: "tablist",
    "aria-orientation": orientation
  }, sharedStylingProps, TabListProps), react.Children.map(children, function (child, index) {
    if (!child) return;
    return /*#__PURE__*/react.createElement(InternalTab, _extends({
      childKey: child.key,
      childIndex: index,
      activeKey: activeKey,
      orientation: orientation,
      activeTabRef: activeTabRef,
      updateHighlight: updateHighlight,
      parseKeyDown: parseKeyDown,
      activateOnFocus: activateOnFocus,
      uid: uid,
      disabled: disabled,
      sharedStylingProps: sharedStylingProps,
      onChange: onChange
    }, child.props));
  }), /*#__PURE__*/react.createElement(TabHighlight, _extends({
    "data-baseweb": "tab-highlight",
    $length: highlightLayout.length,
    $distance: highlightLayout.distance // This avoids the tab sliding in from the side on mount
    ,
    $animate: keyUpdated > 1,
    "aria-hidden": "true",
    role: "presentation"
  }, sharedStylingProps, TabHighlightProps))), /*#__PURE__*/react.createElement(TabBorder, _extends({
    "data-baseweb": "tab-border",
    "aria-hidden": "true",
    role: "presentation"
  }, sharedStylingProps, TabBorderProps)), react.Children.map(children, function (child, index) {
    if (!child) return;
    return /*#__PURE__*/react.createElement(InternalTabPanel, _extends({
      childKey: child.key,
      childIndex: index,
      activeKey: activeKey,
      uid: uid,
      sharedStylingProps: sharedStylingProps,
      renderAll: renderAll
    }, child.props));
  }));
}

function InternalTab(_ref2) {
  var childKey = _ref2.childKey,
      childIndex = _ref2.childIndex,
      activeKey = _ref2.activeKey,
      orientation = _ref2.orientation,
      activeTabRef = _ref2.activeTabRef,
      updateHighlight = _ref2.updateHighlight,
      parseKeyDown = _ref2.parseKeyDown,
      activateOnFocus = _ref2.activateOnFocus,
      uid = _ref2.uid,
      disabled = _ref2.disabled,
      sharedStylingProps = _ref2.sharedStylingProps,
      onChange = _ref2.onChange,
      props = _objectWithoutProperties(_ref2, ["childKey", "childIndex", "activeKey", "orientation", "activeTabRef", "updateHighlight", "parseKeyDown", "activateOnFocus", "uid", "disabled", "sharedStylingProps", "onChange"]);

  var key = childKey || String(childIndex);
  var isActive = key == activeKey;

  var Artwork = props.artwork,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      tabRef = props.tabRef,
      _onClick = props.onClick,
      title = props.title,
      restProps = _objectWithoutProperties(props, ["artwork", "overrides", "tabRef", "onClick", "title"]); // A way to share our internal activeTabRef via the "tabRef" prop.


  var ref = react.useRef();
  react.useImperativeHandle(tabRef, function () {
    return isActive ? activeTabRef.current : ref.current;
  }); // Track tab dimensions in a ref after each render
  // This is used to compare params when the resize observer fires

  var tabLayoutParams = react.useRef({
    length: 0,
    distance: 0
  });
  react.useEffect(function () {
    tabLayoutParams.current = getLayoutParams(isActive ? activeTabRef.current : ref.current, orientation);
  }); // We need to potentially update the active tab highlight when the width or
  // placement changes for a tab so we listen for resize updates in each tab.

  react.useEffect(function () {
    if (window.ResizeObserver) {
      var observer = new window.ResizeObserver(function (entries) {
        if (entries[0] && entries[0].target) {
          var tabLayoutParamsAfterResize = getLayoutParams(entries[0].target, orientation);

          if (tabLayoutParamsAfterResize.length !== tabLayoutParams.current.length || tabLayoutParamsAfterResize.distance !== tabLayoutParams.current.distance) {
            updateHighlight();
          }
        }
      });
      observer.observe(isActive ? activeTabRef.current : ref.current);
      return function () {
        observer.disconnect();
      };
    }
  }, [activeKey, orientation]);
  react.useEffect(updateHighlight, [title]); // Collect overrides

  var TabOverrides = overrides.Tab,
      ArtworkContainerOverrides = overrides.ArtworkContainer;

  var _getOverrides9 = (0,helpers_overrides/* getOverrides */.jb)(TabOverrides, StyledTab),
      _getOverrides10 = _slicedToArray(_getOverrides9, 2),
      Tab = _getOverrides10[0],
      TabProps = _getOverrides10[1];

  var _getOverrides11 = (0,helpers_overrides/* getOverrides */.jb)(ArtworkContainerOverrides, StyledArtworkContainer),
      _getOverrides12 = _slicedToArray(_getOverrides11, 2),
      ArtworkContainer = _getOverrides12[0],
      ArtworkContainerProps = _getOverrides12[1]; // Keyboard focus styling


  var _React$useState5 = react.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      focusVisible = _React$useState6[0],
      setFocusVisible = _React$useState6[1];

  var handleFocus = react.useCallback(function (event) {
    if ((0,utils_focusVisible/* isFocusVisible */.E)(event)) {
      setFocusVisible(true);
    }
  }, []);
  var handleBlur = react.useCallback(function (event) {
    if (focusVisible !== false) {
      setFocusVisible(false);
    }
  }, [focusVisible]); // Keyboard focus management

  var handleKeyDown = react.useCallback(function (event) {
    // WAI-ARIA 1.1
    // https://www.w3.org/TR/wai-aria-practices-1.1/#tabpanel
    // We use directional keys to iterate focus through Tabs.
    // Find all tabs eligible for focus
    var availableTabs = _toConsumableArray(event.target.parentNode.childNodes).filter(function (node) {
      return !node.disabled && node.getAttribute('role') === 'tab';
    }); // Exit early if there are no other tabs available


    if (availableTabs.length === 1) return; // Find tab to focus, looping to start/end of list if necessary

    var currentTabIndex = availableTabs.indexOf(event.target);
    var action = parseKeyDown(event);

    if (action) {
      var nextTab;

      if (action === KEYBOARD_ACTION.previous) {
        if (availableTabs[currentTabIndex - 1]) {
          nextTab = availableTabs[currentTabIndex - 1];
        } else {
          nextTab = availableTabs[availableTabs.length - 1];
        }
      } else if (action === KEYBOARD_ACTION.next) {
        if (availableTabs[currentTabIndex + 1]) {
          nextTab = availableTabs[currentTabIndex + 1];
        } else {
          nextTab = availableTabs[0];
        }
      }

      if (nextTab) {
        // Focus the tab
        nextTab.focus(); // Optionally activate the tab

        if (activateOnFocus) {
          nextTab.click();
        }
      } // Prevent default page scroll when in vertical orientation


      if (isVertical(orientation)) {
        event.preventDefault();
      }
    }
  });
  return /*#__PURE__*/react.createElement(Tab, _extends({
    "data-baseweb": "tab",
    key: key,
    id: getTabId(uid, key),
    role: "tab",
    onKeyDown: handleKeyDown,
    "aria-selected": isActive,
    "aria-controls": getTabPanelId(uid, key),
    tabIndex: isActive ? '0' : '-1',
    ref: isActive ? activeTabRef : ref,
    disabled: !isActive && disabled,
    type: "button" // so it doesn't trigger a submit when used inside forms
    ,
    $focusVisible: focusVisible,
    $isActive: isActive
  }, sharedStylingProps, restProps, TabProps, {
    onClick: function onClick(event) {
      if (typeof onChange === 'function') onChange({
        activeKey: key
      });
      if (typeof _onClick === 'function') _onClick(event);
    },
    onFocus: (0,utils_focusVisible/* forkFocus */.Ah)(tabs_objectSpread(tabs_objectSpread({}, restProps), TabProps), handleFocus),
    onBlur: (0,utils_focusVisible/* forkBlur */.Z5)(tabs_objectSpread(tabs_objectSpread({}, restProps), TabProps), handleBlur)
  }), Artwork ? /*#__PURE__*/react.createElement(ArtworkContainer, _extends({
    "data-baseweb": "artwork-container"
  }, sharedStylingProps, ArtworkContainerProps), /*#__PURE__*/react.createElement(Artwork, {
    size: 20,
    color: "contentPrimary"
  })) : null, title ? title : key);
}

function InternalTabPanel(_ref3) {
  var childKey = _ref3.childKey,
      childIndex = _ref3.childIndex,
      activeKey = _ref3.activeKey,
      uid = _ref3.uid,
      sharedStylingProps = _ref3.sharedStylingProps,
      renderAll = _ref3.renderAll,
      props = _objectWithoutProperties(_ref3, ["childKey", "childIndex", "activeKey", "uid", "sharedStylingProps", "renderAll"]);

  var key = childKey || String(childIndex);
  var isActive = key == activeKey;
  var _props$overrides2 = props.overrides,
      overrides = _props$overrides2 === void 0 ? {} : _props$overrides2,
      children = props.children;
  var TabPanelOverrides = overrides.TabPanel;

  var _getOverrides13 = (0,helpers_overrides/* getOverrides */.jb)(TabPanelOverrides, StyledTabPanel),
      _getOverrides14 = _slicedToArray(_getOverrides13, 2),
      TabPanel = _getOverrides14[0],
      TabPanelProps = _getOverrides14[1];

  return /*#__PURE__*/react.createElement(TabPanel, _extends({
    "data-baseweb": "tab-panel",
    key: key,
    role: "tabpanel",
    id: getTabPanelId(uid, key),
    "aria-labelledby": getTabId(uid, key),
    hidden: !isActive
  }, sharedStylingProps, TabPanelProps), isActive || renderAll ? children : null);
}

/***/ })

}]);